export {default} from './PromotionReportContent';
export {Loading} from './Loading';
